import React from 'react';
import { Segmented } from 'antd';

import FieldMessage from './FieldMessage';

/**
 * One labelled control of the builder, with its messages under it (a
 * refusal on the field its path names, a hint, a note). `id` is the
 * control's own id — colon-free, so a role query never trips jsdom's
 * selector engine (knowledge: web tests beyond the runbook) — and its
 * messages' id is `${id}-messages`.
 */
export function Field({ id, label, messages = [], children, className = '', hint = null }) {
	return (
		<div className={['chart-builder__field', className].filter(Boolean).join(' ')} data-field={id}>
			{label ? <label htmlFor={id} className='chart-builder__label'>{label}</label> : null}
			{children}
			{hint ? <div className='chart-builder__hint'>{hint}</div> : null}
			<FieldMessage messages={messages} id={`${id}-messages`} />
		</div>
	);
}

/**
 * A 2–5 way choice (standards §9 7b: a Segmented), labelled for a screen
 * reader by the words above it. antd's Segmented carries no group role of
 * its own, so the wrapper does.
 */
export function SegmentedField({ id, label, value, options, onChange, messages = [], hint = null, disabled = false }) {
	const labelId = `${id}-label`;
	return (
		<div className='chart-builder__field' data-field={id}>
			<span className='chart-builder__label' id={labelId}>{label}</span>
			<div role='group' aria-labelledby={labelId} className='chart-builder__segmented'>
				<Segmented id={id} value={value} options={options} onChange={onChange} disabled={disabled} />
			</div>
			{hint ? <div className='chart-builder__hint'>{hint}</div> : null}
			<FieldMessage messages={messages} id={`${id}-messages`} />
		</div>
	);
}
